import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table, Tag, Space, Button, Pagination, DatePicker, Popconfirm, Select, Input, Col, Row } from "antd";
import { EditOutlined, DeleteOutlined, PrinterOutlined } from "@ant-design/icons";
import "./mineralTesting.scss";
import { NavLink } from "react-router-dom";
import { getMineralReports, deleteMineralReport } from "../../../modules/actions/mineralActions";
import { dateFormat } from "../../../common/common";
import logo from "../../../Images/Logo 2.png";

const { Option } = Select;
const { Column } = Table;

function MineralTesting(props) {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [searchBool, setSearchBool] = useState(false);

    useEffect(() => {
        const branchCode = props.permission && props.permission.branchCode ? props.permission.branchCode : "KHI";
        if (branchCode) {
            const filters = {
                page: page,
                page_size: pageSize,
                status: statusFilter,
                searchText: searchText,
                start_date: startDate,
                end_date: endDate
            };
            props.getMineralReports(filters, branchCode);
        }
    }, [searchBool, startDate, endDate, statusFilter, page, pageSize]);

    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (props.mineralReports) {
            setData(props.mineralReports);
            setTotal(props.reportTotal);
        }
    }, [props.mineralReports]);

    const getStatusColor = (status) => {
        if (status === "PENDING") return "orange";
        if (status === "IN_ANALYSIS") return "blue";
        if (status === "COMPLETED") return "green";
        return "default";
    };

    const handleDelete = (reportNo) => {
        const branchCode = props.permission && props.permission.branchCode ? props.permission.branchCode : "KHI";
        props.deleteMineralReport(reportNo, () => {
            const filters = {
                page: page,
                page_size: pageSize,
                status: statusFilter,
                searchText: searchText
            };
            props.getMineralReports(filters, branchCode);
        });
    };

    return (
        <div className="mineralTesting">
            <div className="innerMineralTesting">
                <div className="headerTitle">
                    <h2>Mineral Testing</h2>
                </div>

                <div className="filter">
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6} xl={6} style={{ marginRight: 10 }}>
                            <Input.Search
                                enterButton
                                onSearch={(e) => {
                                    setSearchText(e);
                                    setSearchBool(!searchBool);
                                }}
                                placeholder="Search Report No / Entry No / Customer"
                            />
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{ marginRight: 10 }}>
                            <Select
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e)}
                                className="w100P"
                                allowClear
                            >
                                <Option value="">All Status</Option>
                                <Option value="PENDING">Pending</Option>
                                <Option value="IN_ANALYSIS">In Analysis</Option>
                                <Option value="COMPLETED">Completed</Option>
                            </Select>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{ marginRight: 10 }}>
                            <DatePicker
                                onChange={(e) => setStartDate(e ? dateFormat(e) : "")}
                                className="w100P"
                                placeholder="Start Date"
                            />
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                            <DatePicker
                                onChange={(e) => setEndDate(e ? dateFormat(e) : "")}
                                className="w100P"
                                placeholder="End Date"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="tableDiv">
                    {props.mineralReportLoading ? (
                        <div className="loaderDiv tableLoader">
                            <div>
                                <img src={logo} alt="Loading" />
                            </div>
                        </div>
                    ) : null}

                    <Table
                        pagination={false}
                        className="itemsTable"
                        dataSource={data}
                        rowKey="reportNo"
                    >
                        <Column
                            title="Report No"
                            dataIndex="reportNo"
                            key="reportNo"
                            width={180}
                        />
                        <Column
                            title="Entry No"
                            dataIndex="entryNo"
                            key="entryNo"
                            width={160}
                        />
                        <Column
                            title="Customer"
                            key="customer"
                            render={(text, record) =>
                                record.customer ? record.customer.customerName : record.client || "-"
                            }
                        />
                        <Column
                            title="Sample Description"
                            dataIndex="sampleDescription"
                            key="sampleDescription"
                        />
                        <Column
                            title="Date of Analysis"
                            dataIndex="dateOfAnalysis"
                            key="dateOfAnalysis"
                        />
                        <Column
                            title="Status"
                            dataIndex="status"
                            key="status"
                            render={(text) => (
                                <Tag color={getStatusColor(text)}>{text}</Tag>
                            )}
                        />
                        <Column
                            title="Actions"
                            key="actions"
                            render={(text, record) => (
                                <Space size="small">
                                    <NavLink to={`/mineral-testing-print/${record.reportNo}`}>
                                        <Button
                                            type="primary"
                                            size="small"
                                            icon={<PrinterOutlined />}
                                        >
                                            Print
                                        </Button>
                                    </NavLink>
                                    <NavLink to={`/mineral-testing-form/${record.entryNo}`}>
                                        <Button
                                            size="small"
                                            icon={<EditOutlined />}
                                        >
                                            Edit
                                        </Button>
                                    </NavLink>
                                    <Popconfirm
                                        title="Are you sure to delete this report?"
                                        onConfirm={() => handleDelete(record.reportNo)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button
                                            danger
                                            size="small"
                                            icon={<DeleteOutlined />}
                                        />
                                    </Popconfirm>
                                </Space>
                            )}
                        />
                    </Table>

                    <div className="paginationDiv">
                        <Pagination
                            current={page}
                            pageSize={pageSize}
                            total={total}
                            onChange={(page, pageSize) => {
                                setPage(page);
                                setPageSize(pageSize);
                            }}
                            showSizeChanger
                            showTotal={(total) => `Total ${total} items`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        mineralReports: state.mineralStore.mineralReports,
        reportTotal: state.mineralStore.reportTotal,
        mineralReportLoading: state.mineralStore.mineralReportLoading,
        permission: state.authentication.permission,
        userPermissions: state.authentication.userPermissions
    };
};

const mapDispatchToProps = (dispatch) => ({
    getMineralReports: (filters, branchCode) => dispatch(getMineralReports(filters, branchCode)),
    deleteMineralReport: (reportNo, callback) => dispatch(deleteMineralReport(reportNo, callback))
});

export default connect(mapStateToProps, mapDispatchToProps)(MineralTesting);